import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { StaffForm } from 'src/components/organisms/staff/form';
import Page from 'src/components/molecules/page';

export const StaffCreatePage: FC = () => {
  const title = 'スタッフ新規';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <StaffForm />
      </Container>
    </Page>
  );
};
